"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6556],{

/***/ 43605:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(186);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71849);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: ",
        ";\n  border-radius: 16px;\n  box-shadow: ",
        ";\n  color: ",
        ";\n  display: block;\n  font-size: 16px;\n  height: ",
        ";\n  outline: 0;\n  padding: 0 16px;\n  width: 100%;\n  border: 1px solid ",
        ";\n\n  &::placeholder {\n    color: ",
        ";\n  }\n\n  &:disabled {\n    background-color: ",
        ";\n    box-shadow: none;\n    color: ",
        ";\n    cursor: not-allowed;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


/**
 * Priority: Warning --> Success
 */ var getBoxShadow = function(param) {
    var _isSuccess = param.isSuccess, isSuccess = _isSuccess === void 0 ? false : _isSuccess, _isWarning = param.isWarning, isWarning = _isWarning === void 0 ? false : _isWarning, theme = param.theme;
    if (isWarning) {
        return theme.shadows.warning;
    }
    if (isSuccess) {
        return theme.shadows.success;
    }
    return theme.shadows.inset;
};
var getHeight = function(param) {
    var _scale = param.scale, scale = _scale === void 0 ? _types__WEBPACK_IMPORTED_MODULE_1__/* .scales.MD */ .Q.MD : _scale;
    switch(scale){
        case _types__WEBPACK_IMPORTED_MODULE_1__/* .scales.SM */ .Q.SM:
            return "32px";
        case _types__WEBPACK_IMPORTED_MODULE_1__/* .scales.LG */ .Q.LG:
            return "48px";
        case _types__WEBPACK_IMPORTED_MODULE_1__/* .scales.MD */ .Q.MD:
        default:
            return "40px";
    }
};
var Input = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].input.withConfig */ .ZP.input.withConfig({
    componentId: "sc-16dacbf7-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.input;
}, getBoxShadow, function(param) {
    var theme = param.theme;
    return theme.colors.text;
}, getHeight, function(param) {
    var theme = param.theme;
    return theme.colors.inputSecondary;
}, function(param) {
    var theme = param.theme;
    return theme.colors.textSubtle;
}, function(param) {
    var theme = param.theme;
    return theme.colors.backgroundDisabled;
}, function(param) {
    var theme = param.theme;
    return theme.colors.textDisabled;
});
Input.defaultProps = {
    scale: _types__WEBPACK_IMPORTED_MODULE_1__/* .scales.MD */ .Q.MD,
    isSuccess: false,
    isWarning: false
};
/* harmony default export */ __webpack_exports__["Z"] = (Input);


/***/ }),

/***/ 71849:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ scales; }
/* harmony export */ });
var scales = {
    SM: "sm",
    MD: "md",
    LG: "lg"
};


/***/ }),

/***/ 7269:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BY": function() { return /* binding */ LP_HOLDERS_FEE; },
/* harmony export */   "Bq": function() { return /* binding */ ONE_DAY_UNIX; },
/* harmony export */   "DY": function() { return /* binding */ PCS_ETH_START; },
/* harmony export */   "MV": function() { return /* binding */ WEEKS_IN_YEAR; },
/* harmony export */   "OZ": function() { return /* binding */ MINIMUM_SEARCH_CHARACTERS; },
/* harmony export */   "Rr": function() { return /* binding */ PCS_V2_START; },
/* harmony export */   "Tb": function() { return /* binding */ ONE_HOUR_SECONDS; },
/* harmony export */   "Vd": function() { return /* binding */ ETH_TOKEN_BLACKLIST; },
/* harmony export */   "hT": function() { return /* binding */ TREASURY_FEE; },
/* harmony export */   "om": function() { return /* binding */ TOTAL_FEE; },
/* harmony export */   "si": function() { return /* binding */ ITEMS_PER_INFO_TABLE_PAGE; },
/* harmony export */   "tE": function() { return /* binding */ TOKEN_BLACKLIST; },
/* harmony export */   "xy": function() { return /* binding */ BUYBACK_FEE; }
/* harmony export */ });
var MINIMUM_SEARCH_CHARACTERS = 2;
var WEEKS_IN_YEAR = 52.1429;
var TOTAL_FEE = 0.0025;
var LP_HOLDERS_FEE = 0.0017;
var TREASURY_FEE = 0.000225;
var BUYBACK_FEE = 0.000575;
var PCS_V2_START = 1684557476 // April 23, 2021, 12:00:00 AM
;
var PCS_ETH_START = 1664130827 // Sep 23, 2022, 02:33:47 AM
;
var ONE_DAY_UNIX = 86400 // 24h * 60m * 60s
;
var ONE_HOUR_SECONDS = 3600;
var ITEMS_PER_INFO_TABLE_PAGE = 10;
// These tokens are either incorrectly priced or have some other issues that spoil the query data
// None of them present any interest as they have almost 0 daily trade volume
var TOKEN_BLACKLIST = [];
var ETH_TOKEN_BLACKLIST = [
    "0x72b169ad8af6c4fb53056b6a2a85602ad6863864"
];


/***/ }),

/***/ 72505:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cv": function() { return /* binding */ GetchPoolData; }
/* harmony export */ });
/* unused harmony export parsePoolData */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(20414);
/* harmony import */ var graphql_request__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28687);
/* harmony import */ var graphql_request__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(graphql_request__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var utils_graphql__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61417);
/* harmony import */ var utils_getChangeForPeriod__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(28839);
/* harmony import */ var utils_getLpFeesAndApr__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(67621);
/* harmony import */ var utils_getDeltaTimestamps__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(45802);
/* harmony import */ var views_Info_hooks_useBlocksFromTimestamps__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57487);
/* harmony import */ var views_Info_utils_infoDataHelpers__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(86535);
/* eslint-disable no-param-reassign */ 





function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      query pools {\n        now: ",
        "\n        oneDayAgo: ",
        "\n        twoDaysAgo: ",
        "\n        oneWeekAgo: ",
        "\n        twoWeeksAgo: ",
        "\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}








/**
 * Data for displaying pool tables (on multiple pages, used throughout the site)
 * Note: Don't try to refactor it to use variables, server throws error if blocks passed as undefined variable
 * only works if its hard-coded into query string
 */ var POOL_AT_BLOCK = function(block, pools) {
    var blockString = block ? "block: {number: ".concat(block, "}") : "";
    var addressesString = '["'.concat(pools.join('","'), '"]');
    return "pairs(\n    where: { id_in: ".concat(addressesString, " }\n    ").concat(blockString, "\n    orderBy: trackedReserveETH\n    orderDirection: desc\n  ) {\n    id\n    reserve0\n    reserve1\n    reserveUSD\n    volumeUSD\n    token0Price\n    token1Price\n    token0 {\n      id\n      symbol\n      name\n    }\n    token1 {\n      id\n      symbol\n      name\n    }\n  }");
};
var GetchPoolData = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(block24h, block48h, block7d, block14d, poolAddresses) {
        var query, data, error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    query = (0,graphql_request__WEBPACK_IMPORTED_MODULE_1__.gql)(_templateObject(), POOL_AT_BLOCK(null, poolAddresses), POOL_AT_BLOCK(block24h, poolAddresses), POOL_AT_BLOCK(block48h, poolAddresses), POOL_AT_BLOCK(block7d, poolAddresses), POOL_AT_BLOCK(block14d, poolAddresses));
                    return [
                        4,
                        utils_graphql__WEBPACK_IMPORTED_MODULE_3__/* .infoClient.request */ .dQ.request(query)
                    ];
                case 1:
                    data = _state.sent();
                    console.log("poolData", data);
                    return [
                        2,
                        {
                            data: data,
                            error: false
                        }
                    ];
                case 2:
                    error = _state.sent();
                    console.error("Failed to fetch pool data", error);
                    return [
                        2,
                        {
                            error: true
                        }
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function GetchPoolData(block24h, block48h, block7d, block14d, poolAddresses) {
        return _ref.apply(this, arguments);
    };
}();
// Transforms pools into "0xADDRESS: { ...PoolFields }" format and cast strings to numbers
var parsePoolData = function(pairs) {
    if (!pairs) {
        return {};
    }
    return pairs.reduce(function(accum, poolData) {
        var volumeUSD = poolData.volumeUSD, reserveUSD = poolData.reserveUSD, reserve0 = poolData.reserve0, reserve1 = poolData.reserve1, token0Price = poolData.token0Price, token1Price = poolData.token1Price;
        accum[poolData.id] = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, poolData), {
            volumeUSD: parseFloat(volumeUSD),
            reserveUSD: parseFloat(reserveUSD),
            reserve0: parseFloat(reserve0),
            reserve1: parseFloat(reserve1),
            token0Price: parseFloat(token0Price),
            token1Price: parseFloat(token1Price)
        });
        return accum;
    }, {});
};
/**
 * Fetch top pools by liquidity
 */ var usePoolDatas = function(poolAddresses) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({
        error: false
    }), fetchState = ref[0], setFetchState = ref[1];
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,utils_getDeltaTimestamps__WEBPACK_IMPORTED_MODULE_10__/* .getDeltaTimestamps */ .z)(), 4), t24h = ref1[0], t48h = ref1[1], t7d = ref1[2], t14d = ref1[3];
    var ref2 = (0,views_Info_hooks_useBlocksFromTimestamps__WEBPACK_IMPORTED_MODULE_4__/* .useBlocksFromTimestamps */ .Z)([
        t24h,
        t48h,
        t7d,
        t14d
    ]), blocks = ref2.blocks, blockError = ref2.error;
    var ref3 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(blocks !== null && blocks !== void 0 ? blocks : [], 4), block24h = ref3[0], block48h = ref3[1], block7d = ref3[2], block14d = ref3[3];
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var fetch = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                var ref, error, data, formattedPoolData, formattedPoolData24h, formattedPoolData48h, formattedPoolData7d, formattedPoolData14d, formatted;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                GetchPoolData(block24h.number, block48h.number, block7d.number, block14d.number, poolAddresses)
                            ];
                        case 1:
                            ref = _state.sent(), error = ref.error, data = ref.data;
                            if (error) {
                                setFetchState({
                                    error: true
                                });
                            } else {
                                formattedPoolData = parsePoolData(data === null || data === void 0 ? void 0 : data.now);
                                formattedPoolData24h = parsePoolData(data === null || data === void 0 ? void 0 : data.oneDayAgo);
                                formattedPoolData48h = parsePoolData(data === null || data === void 0 ? void 0 : data.twoDaysAgo);
                                formattedPoolData7d = parsePoolData(data === null || data === void 0 ? void 0 : data.oneWeekAgo);
                                formattedPoolData14d = parsePoolData(data === null || data === void 0 ? void 0 : data.twoWeeksAgo);
                                formatted = poolAddresses.reduce(function(accum, address) {
                                    // Undefined data is possible if pool is brand new and didn't exist one day ago or week ago.
                                    var current = formattedPoolData[address];
                                    var oneDay = formattedPoolData24h[address];
                                    var twoDays = formattedPoolData48h[address];
                                    var week = formattedPoolData7d[address];
                                    var twoWeeks = formattedPoolData14d[address];
                                    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,utils_getChangeForPeriod__WEBPACK_IMPORTED_MODULE_11__/* .getChangeForPeriod */ .T)(current === null || current === void 0 ? void 0 : current.volumeUSD, oneDay === null || oneDay === void 0 ? void 0 : oneDay.volumeUSD, twoDays === null || twoDays === void 0 ? void 0 : twoDays.volumeUSD), 2), volumeUSD = ref[0], volumeUSDChange = ref[1];
                                    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,utils_getChangeForPeriod__WEBPACK_IMPORTED_MODULE_11__/* .getChangeForPeriod */ .T)(current === null || current === void 0 ? void 0 : current.volumeUSD, week === null || week === void 0 ? void 0 : week.volumeUSD, twoWeeks === null || twoWeeks === void 0 ? void 0 : twoWeeks.volumeUSD), 2), volumeUSDWeek = ref1[0], volumeUSDChangeWeek = ref1[1];
                                    var liquidityUSD = current ? current.reserveUSD : 0;
                                    var liquidityUSDChange = (0,views_Info_utils_infoDataHelpers__WEBPACK_IMPORTED_MODULE_12__/* .getPercentChange */ .Y)(current === null || current === void 0 ? void 0 : current.reserveUSD, oneDay === null || oneDay === void 0 ? void 0 : oneDay.reserveUSD);
                                    var liquidityToken0 = current ? current.reserve0 : 0;
                                    var liquidityToken1 = current ? current.reserve1 : 0;
                                    var ref2 = (0,utils_getLpFeesAndApr__WEBPACK_IMPORTED_MODULE_13__/* .getLpFeesAndApr */ .z)(volumeUSD, volumeUSDWeek, liquidityUSD), totalFees24h = ref2.totalFees24h, totalFees7d = ref2.totalFees7d, lpFees24h = ref2.lpFees24h, lpFees7d = ref2.lpFees7d, lpApr7d = ref2.lpApr7d;
                                    if (current) {
                                        accum[address] = {
                                            address: address,
                                            token0: {
                                                address: current.token0.id,
                                                name: current.token0.name,
                                                symbol: current.token0.symbol
                                            },
                                            token1: {
                                                address: current.token1.id,
                                                name: current.token1.name,
                                                symbol: current.token1.symbol
                                            },
                                            token0Price: current.token0Price,
                                            token1Price: current.token1Price,
                                            volumeUSD: volumeUSD,
                                            volumeUSDChange: volumeUSDChange,
                                            volumeUSDWeek: volumeUSDWeek,
                                            volumeUSDChangeWeek: volumeUSDChangeWeek,
                                            totalFees24h: totalFees24h,
                                            totalFees7d: totalFees7d,
                                            lpFees24h: lpFees24h,
                                            lpFees7d: lpFees7d,
                                            lpApr7d: lpApr7d,
                                            liquidityUSD: liquidityUSD,
                                            liquidityUSDChange: liquidityUSDChange,
                                            liquidityToken0: liquidityToken0,
                                            liquidityToken1: liquidityToken1
                                        };
                                    }
                                    return accum;
                                }, {});
                                setFetchState({
                                    data: formatted,
                                    error: false
                                });
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetch() {
                return _ref.apply(this, arguments);
            };
        }();
        var allBlocksAvailable = (block24h === null || block24h === void 0 ? void 0 : block24h.number) && (block48h === null || block48h === void 0 ? void 0 : block48h.number) && (block7d === null || block7d === void 0 ? void 0 : block7d.number) && (block14d === null || block14d === void 0 ? void 0 : block14d.number);
        if (poolAddresses.length > 0 && allBlocksAvailable && !blockError) {
            fetch();
        }
    }, [
        poolAddresses,
        block24h,
        block48h,
        block7d,
        block14d,
        blockError
    ]);
    return fetchState;
};
/* harmony default export */ __webpack_exports__["ZP"] = (usePoolDatas);


/***/ }),

/***/ 23843:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "C": function() { return /* binding */ getBlocksBase; },
  "b": function() { return /* binding */ getBlocksBaseChart; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/@ethersproject/providers/lib.esm/url-json-rpc-provider.js
var url_json_rpc_provider = __webpack_require__(93901);
;// CONCATENATED MODULE: ./src/utils/providersV2.ts

var getProvider = new url_json_rpc_provider/* StaticJsonRpcProvider */.c("https://goerli.base.org");

;// CONCATENATED MODULE: ./src/utils/getBlocksFromTimestampsBase.ts



var getBlocksBase = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(timestamps) {
        var blockNumber, blocks;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        getProvider.getBlockNumber()
                    ];
                case 1:
                    blockNumber = _state.sent();
                    blocks = [];
                    // 24h => blocks (24*60*60/3)
                    blocks.push({
                        timestamp: timestamps[0].toString(),
                        number: Number(blockNumber.toString()) - 28800
                    });
                    // 48h => second => blocks (48*60*60/3)
                    blocks.push({
                        timestamp: timestamps[1].toString(),
                        number: Number(blockNumber.toString()) - 57600
                    });
                    // 7d => blocks (7*24*60*60/3)
                    blocks.push({
                        timestamp: timestamps[2].toString(),
                        number: Number(blockNumber.toString()) - 201600
                    });
                    // 14d => blocks (14*24*60*60/3)
                    blocks.push({
                        timestamp: timestamps[3].toString(),
                        number: Number(blockNumber.toString()) - 403200
                    });
                    return [
                        2,
                        blocks
                    ];
            }
        });
    });
    return function getBlocksBase(timestamps) {
        return _ref.apply(this, arguments);
    };
}();
var getBlocksBaseChart = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(timestamps, times) {
        var blockNumber, blocks, index, element, _blockNumber;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        getProvider.getBlockNumber()
                    ];
                case 1:
                    blockNumber = _state.sent();
                    console.log("blockNumber", blockNumber);
                    blocks = [];
                    for(index = 0; index < timestamps.length; index++){
                        element = Math.floor(Number(times[index]) / 3) + 100;
                        _blockNumber = Number(blockNumber.toString()) - element;
                        blocks.push({
                            timestamp: timestamps[index].toString(),
                            number: _blockNumber
                        });
                    }
                    return [
                        2,
                        blocks
                    ];
            }
        });
    });
    return function getBlocksBaseChart(timestamps, times) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 28839:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ getChangeForPeriod; }
/* harmony export */ });
/* harmony import */ var views_Info_utils_infoDataHelpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86535);

/**
 * Given current value and value 1 and 2 periods (e.g. 1day + 2days, 1week - 2weeks) returns the amount change for latest period
 * and percentage change compared to the previous period.
 * @param valueNow - current value
 * @param valueOnePeriodAgo - value 1 period ago (e.g. 1 day or 1 week ago), period unit must be same as valueTwoPeriodsAgo
 * @param valueTwoPeriodsAgo - value 2 periods ago (e.g. 2 days or 2 weeks ago), period unit must be same as valueOnePeriodAgo
 * @returns amount change for the latest period and percentage change compared to previous period
 */ var getChangeForPeriod = function(valueNow, valueOnePeriodAgo, valueTwoPeriodsAgo) {
    var currentPeriodAmount = (0,views_Info_utils_infoDataHelpers__WEBPACK_IMPORTED_MODULE_0__/* .getAmountChange */ .D)(valueNow, valueOnePeriodAgo);
    var previousPeriodAmount = (0,views_Info_utils_infoDataHelpers__WEBPACK_IMPORTED_MODULE_0__/* .getAmountChange */ .D)(valueOnePeriodAgo, valueTwoPeriodsAgo);
    var percentageChange = (0,views_Info_utils_infoDataHelpers__WEBPACK_IMPORTED_MODULE_0__/* .getPercentChange */ .Y)(currentPeriodAmount, previousPeriodAmount);
    return [
        currentPeriodAmount,
        percentageChange
    ];
};


/***/ }),

/***/ 45802:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ getDeltaTimestamps; }
/* harmony export */ });
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28401);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18717);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7069);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85899);

/**
 * Returns UTC timestamps for 24h ago, 48h ago, 7d ago and 14d ago relative to current date and time
 */ var getDeltaTimestamps = function() {
    var utcCurrentTime = (0,date_fns__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(new Date()) * 1000;
    var t24h = (0,date_fns__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,date_fns__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,date_fns__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(utcCurrentTime, 1)));
    var t48h = (0,date_fns__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,date_fns__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,date_fns__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(utcCurrentTime, 2)));
    var t7d = (0,date_fns__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,date_fns__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,date_fns__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(utcCurrentTime, 1)));
    var t14d = (0,date_fns__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,date_fns__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,date_fns__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(utcCurrentTime, 2)));
    return [
        t24h,
        t48h,
        t7d,
        t14d
    ];
};


/***/ }),

/***/ 67621:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ getLpFeesAndApr; }
/* harmony export */ });
/* harmony import */ var _config_constants_info__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7269);

var getLpFeesAndApr = function(volumeUSD, volumeUSDWeek, liquidityUSD) {
    var totalFees24h = volumeUSD * _config_constants_info__WEBPACK_IMPORTED_MODULE_0__/* .TOTAL_FEE */ .om;
    var totalFees7d = volumeUSDWeek * _config_constants_info__WEBPACK_IMPORTED_MODULE_0__/* .TOTAL_FEE */ .om;
    var lpFees24h = volumeUSD * _config_constants_info__WEBPACK_IMPORTED_MODULE_0__/* .LP_HOLDERS_FEE */ .BY;
    var lpFees7d = volumeUSDWeek * _config_constants_info__WEBPACK_IMPORTED_MODULE_0__/* .LP_HOLDERS_FEE */ .BY;
    var lpApr7d = liquidityUSD > 0 ? volumeUSDWeek * _config_constants_info__WEBPACK_IMPORTED_MODULE_0__/* .LP_HOLDERS_FEE */ .BY * _config_constants_info__WEBPACK_IMPORTED_MODULE_0__/* .WEEKS_IN_YEAR */ .MV * 100 / liquidityUSD : 0;
    return {
        totalFees24h: totalFees24h,
        totalFees7d: totalFees7d,
        lpFees24h: lpFees24h,
        lpFees7d: lpFees7d,
        lpApr7d: lpApr7d !== Infinity ? lpApr7d : 0
    };
};


/***/ }),

/***/ 61417:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GJ": function() { return /* binding */ infoClientETH; },
/* harmony export */   "dQ": function() { return /* binding */ infoClient; },
/* harmony export */   "iY": function() { return /* binding */ infoClientCloudBase; },
/* harmony export */   "vA": function() { return /* binding */ getGQLHeaders; }
/* harmony export */ });
/* unused harmony exports getGQLHeadersCloud, infoClientWithChain, infoStableSwapClient, infoServerClient, stableSwapClient, bitQueryServerClient */
/* harmony import */ var config_constants_endpoints__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6680);
/* harmony import */ var graphql_request__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28687);
/* harmony import */ var graphql_request__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(graphql_request__WEBPACK_IMPORTED_MODULE_1__);
/* provided dependency */ var process = __webpack_require__(34155);



// Extra headers
// Mostly for dev environment
// No production env check since production preview might also need them
var getGQLHeaders = function(endpoint) {
    if (endpoint === config_constants_endpoints__WEBPACK_IMPORTED_MODULE_0__/* .INFO_CLIENT */ .JY) {
        return {
            "X-Sf": process.env.NEXT_PUBLIC_SF_HEADER || // hack for inject CI secret on window
             true && // @ts-ignore
            window.sfHeader
        };
    }
    return undefined;
};
var getGQLHeadersCloud = function(endpoint) {
    if (endpoint === config_constants_endpoints__WEBPACK_IMPORTED_MODULE_0__/* .ENDPONTS_CLOUDBASE */ .Wt) {
        return {
            "X-Sf": process.env.NEXT_PUBLIC_SF_HEADER || // hack for inject CI secret on window
             true && // @ts-ignore
            window.sfHeader
        };
    }
    return undefined;
};
var infoClient = new graphql_request__WEBPACK_IMPORTED_MODULE_1__.GraphQLClient(config_constants_endpoints__WEBPACK_IMPORTED_MODULE_0__/* .INFO_CLIENT */ .JY, {
    headers: getGQLHeaders(config_constants_endpoints__WEBPACK_IMPORTED_MODULE_0__/* .INFO_CLIENT */ .JY)
});
var infoClientCloudBase = new graphql_request__WEBPACK_IMPORTED_MODULE_1__.GraphQLClient(config_constants_endpoints__WEBPACK_IMPORTED_MODULE_0__/* .ENDPONTS_CLOUDBASE */ .Wt, {
    headers: getGQLHeadersCloud(config_constants_endpoints__WEBPACK_IMPORTED_MODULE_0__/* .ENDPONTS_CLOUDBASE */ .Wt)
});
var infoClientWithChain = function(chainId) {
    return new GraphQLClient(INFO_CLIENT_WITH_CHAIN[chainId], {
        headers: getGQLHeaders(INFO_CLIENT_WITH_CHAIN[chainId])
    });
};
var infoClientETH = new graphql_request__WEBPACK_IMPORTED_MODULE_1__.GraphQLClient(config_constants_endpoints__WEBPACK_IMPORTED_MODULE_0__/* .INFO_CLIENT_ETH */ .EC);
var infoStableSwapClient = new graphql_request__WEBPACK_IMPORTED_MODULE_1__.GraphQLClient(config_constants_endpoints__WEBPACK_IMPORTED_MODULE_0__/* .STABLESWAP_SUBGRAPH_CLIENT */ .gr);
var infoServerClient = new graphql_request__WEBPACK_IMPORTED_MODULE_1__.GraphQLClient(config_constants_endpoints__WEBPACK_IMPORTED_MODULE_0__/* .INFO_CLIENT */ .JY, {
    headers: {
        "X-Sf": process.env.SF_HEADER
    },
    timeout: 5000
});
var stableSwapClient = new graphql_request__WEBPACK_IMPORTED_MODULE_1__.GraphQLClient(config_constants_endpoints__WEBPACK_IMPORTED_MODULE_0__/* .STABLESWAP_SUBGRAPH_CLIENT */ .gr, {
    headers: getGQLHeaders(config_constants_endpoints__WEBPACK_IMPORTED_MODULE_0__/* .STABLESWAP_SUBGRAPH_CLIENT */ .gr)
});
var bitQueryServerClient = new graphql_request__WEBPACK_IMPORTED_MODULE_1__.GraphQLClient(config_constants_endpoints__WEBPACK_IMPORTED_MODULE_0__/* .BIT_QUERY */ .d$, {
    headers: {
        // only server, no `NEXT_PUBLIC` not going to expose in client
        "X-API-KEY": process.env.BIT_QUERY_HEADER
    },
    timeout: 5000
});


/***/ }),

/***/ 2862:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var requestWithTimeout = function(graphQLClient, request, variables) {
    var timeout = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 30000;
    return Promise.race([
        variables ? graphQLClient.request(request, variables) : graphQLClient.request(request),
        new Promise(function(_, reject) {
            setTimeout(function() {
                reject(new Error("Request timed out after ".concat(timeout, " milliseconds")));
            }, timeout);
        }), 
    ]);
};
/* harmony default export */ __webpack_exports__["Z"] = (requestWithTimeout);


/***/ }),

/***/ 57487:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useBlocksFromTimestamps; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20414);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var utils_getBlocksFromTimestampsBase__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23843);




/**
 * for a given array of timestamps, returns block entities
 * @param timestamps
 * @param sortDirection
 * @param skipCount
 */ var useBlocksFromTimestamps = function(timestamps) {
    var skipCount = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1000;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(), blocks = ref[0], setBlocks = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), error = ref1[0], setError = ref1[1];
    var timestampsString = JSON.stringify(timestamps);
    var blocksString = blocks ? JSON.stringify(blocks) : undefined;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var fetchData = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
                var result;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                (0,utils_getBlocksFromTimestampsBase__WEBPACK_IMPORTED_MODULE_1__/* .getBlocksBase */ .C)(timestamps)
                            ];
                        case 1:
                            result = _state.sent();
                            if (result.length === 0) {
                                setError(true);
                            } else {
                                setBlocks(result);
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchData() {
                return _ref.apply(this, arguments);
            };
        }();
        var blocksArray = blocksString ? JSON.parse(blocksString) : undefined;
        if (!blocksArray && !error) {
            fetchData();
        }
    }, [
        blocksString,
        error,
        skipCount,
        timestampsString
    ]);
    return {
        blocks: blocks,
        error: error
    };
};


/***/ }),

/***/ 86535:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ getAmountChange; },
/* harmony export */   "Y": function() { return /* binding */ getPercentChange; }
/* harmony export */ });
/**
 * Get increase/decrease of value compared to the previous value (e.g. 24h volume compared to 24h volume the day before )
 * @param valueNow - more recent value
 * @param valueBefore - value to compare with
 */ var getAmountChange = function(valueNow, valueBefore) {
    if (valueNow && valueBefore) {
        return valueNow - valueBefore;
    }
    if (valueNow) {
        return valueNow;
    }
    return 0;
};
/**
 * Get increase/decrease of value compared to the previous value as a percentage
 * @param valueNow - more recent value
 * @param valueBefore - value to compare with
 */ var getPercentChange = function(valueNow, valueBefore) {
    if (valueNow && valueBefore) {
        return (valueNow - valueBefore) / valueBefore * 100;
    }
    return 0;
};


/***/ }),

/***/ 26604:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ multiQuery; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20414);
/* harmony import */ var graphql_request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28687);
/* harmony import */ var graphql_request__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(graphql_request__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var utils_graphql__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61417);
/* harmony import */ var utils_requestWithTimeout__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2862);






/**
 * Helper function to get large amount GraphQL subqueries
 * @param queryConstructor constructor function that combines subqueries
 * @param subqueries individual queries
 * @param endpoint GraphQL endpoint
 * @param skipCount how many subqueries to fire at a time
 * @returns
 */ var multiQuery = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(queryConstructor, subqueries, endpoint) {
        var skipCount, fetchedData, allFound, skip, client, end, subqueriesSlice, result, error;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    skipCount = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : 1000;
                    fetchedData = {};
                    allFound = false;
                    skip = 0;
                    client = new graphql_request__WEBPACK_IMPORTED_MODULE_0__.GraphQLClient(endpoint, {
                        headers: (0,utils_graphql__WEBPACK_IMPORTED_MODULE_1__/* .getGQLHeaders */ .vA)(endpoint)
                    });
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    if (!!allFound) return [
                        3,
                        3
                    ];
                    end = subqueries.length;
                    if (skip + skipCount < subqueries.length) {
                        end = skip + skipCount;
                    }
                    subqueriesSlice = subqueries.slice(skip, end);
                    return [
                        4,
                        (0,utils_requestWithTimeout__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(client, queryConstructor(subqueriesSlice))
                    ];
                case 2:
                    result = _state.sent();
                    fetchedData = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, fetchedData, result);
                    allFound = Object.keys(result).length < skipCount || skip + skipCount > subqueries.length;
                    skip += skipCount;
                    return [
                        3,
                        1
                    ];
                case 3:
                    return [
                        2,
                        fetchedData
                    ];
                case 4:
                    error = _state.sent();
                    console.error("Failed to fetch info data", error);
                    return [
                        2,
                        null
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return function multiQuery(queryConstructor, subqueries, endpoint) {
        return _ref.apply(this, arguments);
    };
}();


/***/ })

}]);